import { CaretDown, FilePdf, SlidersHorizontal } from "@phosphor-icons/react";

export default function DocuSignTermsEditor({ kind, terms, setT, showTerms, setShowTerms, preview, previewing }) {
  return (
    <>
      <button data-testid="docusign-toggle-terms" onClick={() => setShowTerms((s) => !s)}
        className="w-full flex items-center justify-between px-2 py-2 mb-2 text-sm font-medium border border-border hover:bg-secondary">
        <span className="flex items-center gap-1.5"><SlidersHorizontal size={14} /> Personnaliser les conditions {kind === "nda" && "(clauses)"}</span>
        <CaretDown size={14} className={`transition-transform ${showTerms ? "rotate-180" : ""}`} />
      </button>
      {showTerms && (
        <div className="border border-border p-3 mb-2 space-y-2" data-testid="docusign-terms">
          {kind === "loi" && (
            <div className="grid grid-cols-3 gap-2">
              <div>
                <label className="overline text-muted-foreground">Prix (€)</label>
                <input data-testid="loi-montant" type="number" value={terms.montant} onChange={(e) => setT("montant", e.target.value)}
                  placeholder="médiane" className="w-full mt-1 border border-border px-2 py-1.5 text-sm font-mono" />
              </div>
              <div>
                <label className="overline text-muted-foreground">Exclus. (j)</label>
                <input data-testid="loi-exclusivite" type="number" value={terms.exclusivite_jours} onChange={(e) => setT("exclusivite_jours", e.target.value)}
                  placeholder="90" className="w-full mt-1 border border-border px-2 py-1.5 text-sm font-mono" />
              </div>
              <div>
                <label className="overline text-muted-foreground">Accomp. (mois)</label>
                <input data-testid="loi-accompagnement" type="number" value={terms.accompagnement_mois} onChange={(e) => setT("accompagnement_mois", e.target.value)}
                  placeholder="—" className="w-full mt-1 border border-border px-2 py-1.5 text-sm font-mono" />
              </div>
            </div>
          )}
          <div>
            <label className="overline text-muted-foreground">Conditions particulières / clauses additionnelles</label>
            <textarea data-testid="loi-clauses" value={terms.clauses_extra} onChange={(e) => setT("clauses_extra", e.target.value)} rows={4}
              placeholder="Une clause par ligne (ex : clause de non-concurrence, maintien du personnel…)"
              className="w-full mt-1 border border-border px-2 py-1.5 text-sm resize-y" />
          </div>
          <button data-testid="docusign-preview-btn" onClick={preview} disabled={previewing}
            className="w-full flex items-center justify-center gap-1.5 px-3 py-2 text-sm font-semibold border border-primary text-primary hover:bg-accent disabled:opacity-50">
            <FilePdf size={14} /> {previewing ? "Aperçu…" : "Aperçu PDF"}
          </button>
        </div>
      )}
    </>
  );
}
